import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { ChangePasswordForm } from '../components/ChangePasswordForm';
import { useSession } from '../session';

/** После пароля от администратора: пока пароль не сменён, другие разделы закрыты (в БД тоже). */
export function FirstPasswordPage() {
  const { me, refresh, logout } = useSession();
  return (
    <Center mih="100vh" p="md">
      <Stack gap="md" className="mis-card" p="xl" w="100%" maw={400}>
        <div>
          <Title order={2}>Придумайте пароль</Title>
          <Text c="dimmed" size="sm">
            {me?.name}, пароль для входа выдал администратор. Задайте свой — его будете знать только вы.
          </Text>
        </div>
        <ChangePasswordForm currentLabel="Пароль от администратора" onDone={refresh} />
        <Button variant="subtle" color="gray" onClick={() => void logout()}>
          Выйти
        </Button>
      </Stack>
    </Center>
  );
}
